import React, { useId } from "react";
import { Controller, RegisterOptions, useFormContext } from "react-hook-form";
import Select, { SelectItem, SelectNewOption } from "../select/Select";

interface Props {
  name: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  options?: RegisterOptions;
  items: SelectItem[];
  isMulti?: boolean;
  newOption?: SelectNewOption;
  multivalueTagLabelKey?: string;
  isDisabled?: boolean;
}

const SelectInput: React.FC<Props> = (props): React.ReactElement => {
  const instanceId = useId();
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error } = getFieldState(props.name, formState);

  const showError = !!error && isDirty;

  return (
    <div className="mb-2">
      <Controller
        name={props.name}
        control={control}
        rules={props.options}
        render={({ field }) => (
          <Select
            {...field}
            options={props.items}
            isMulti={props.isMulti}
            placeholder={props.placeholder}
            invalid={invalid}
            newOption={props.newOption}
            multivalueTagLabelKey={props.multivalueTagLabelKey}
            isDisabled={props.isDisabled}
            instanceId={instanceId}
          />
        )}
      />
      {showError && (
        <div className="text-error mt-1 text-[13px]">{error.message}</div>
      )}
    </div>
  );
};

export default SelectInput;
